// removed by extract-text-webpack-plugin
module.exports = {"container":"_38AT_","body":"_3HxEt","carousel":"_1W-89","slide":"_2Qs5C","dots":"_1cCeF","dot":"_1O0Ez","dot-active":"tGWOs _1O0Ez","navigation":"_1O-Bh","next":"oib54 _1O-Bh","previous":"_1qAog _1O-Bh","sr-only":"r5HXU","sr-only-focusable":"OdPve","hero":"_1UGeW","family":"_24IuK _1UGeW","ollie":"_1oWbI _1UGeW","film":"JOM-i _1UGeW","lola":"fwgjy _1UGeW","derry":"_17U3O _1UGeW","brand":"_10EwY","active":"_1zVeQ","statement":"_38slX","action":"_3HJ5D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Hero.less
// module id = ./src/components/Home/Hero.less
// module chunks = 2